import React, { useEffect, useState } from 'react';
import { Translate, translate } from 'react-jhipster';
import { RouteComponentProps } from 'react-router-dom';
import { Col, Row } from 'reactstrap';

import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getEntities as getTruckImplements } from 'app/entities/truck-implement/truck-implement.reducer';
import SelectPaginate from 'app/shared/components/select-paginate/SelectPaginate';
import { BoxForm, FormControlDefault, TextFieldForms, TypographyForms } from 'app/shared/layout/register/DefaultFormsComponents';
import { RegisterButton } from 'app/shared/layout/register/RegisterButton';
import { IBlockScreen } from 'app/shared/model/block-screen.model';
import { createEntity, getEntity, reset, updateEntity } from './block-screen.reducer';

export const BlockScreenUpdate = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  const [isNew] = useState(!props.match.params || !props.match.params.id);

  const blockScreenEntity = useAppSelector(state => state.blockScreen.entity);
  const loading = useAppSelector(state => state.blockScreen.loading);
  const updateSuccess = useAppSelector(state => state.blockScreen.updateSuccess);
  const [formData, setFormData] = useState<IBlockScreen>({
    id: null,
    show: false,
    truckImplement: null,
    createdDate: null,
    lastModifiedDate: null,
  });

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(props.match.params.id));
    }

    dispatch(getTruckImplements({}));
  }, []);

  useEffect(() => {
    if (!isNew) {
      setFormData({
        id: blockScreenEntity?.id,
        show: blockScreenEntity?.show,
        truckImplement: blockScreenEntity?.truckImplement,
      });
    }
  }, [blockScreenEntity]);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    const blockScreen = {
      ...blockScreenEntity,
      ...values,
    };

    if (isNew) {
      dispatch(createEntity(blockScreen));
    } else {
      dispatch(updateEntity(blockScreen));
    }
  };

  const handleClose = () => {
    props.history.push('/block-screen');
  };

  const handleInputChange = (fieldName, value) => {
    setFormData({ ...formData, [fieldName]: value });
  };

  const handleSubmit = () => {
    event.preventDefault();
    saveEntity(formData);
  };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="fleetSenseApp.blockScreen.home.createOrEditLabel" data-cy="BlockScreenCreateUpdateHeading">
            <Translate contentKey="fleetSenseApp.blockScreen.home.createOrEditLabel">Create or edit a BlockScreen</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <BoxForm onSubmit={handleSubmit}>
              {!isNew ? (
                <FormControlDefault sx={{ display: 'none' }}>
                  <TypographyForms>{translate('global.field.id')}</TypographyForms>
                  <TextFieldForms value={formData['id']} id={'block-screen-id'} name={'id'} />
                </FormControlDefault>
              ) : null}
              <FormControlDefault>
                <SelectPaginate
                  label={translate('fleetSenseApp.blockScreen.truckImplement')}
                  apiUrl={'api/truck-implements/search'}
                  onChange={value => handleInputChange('truckImplement', value)}
                  value={formData['truckImplement']}
                  valueName="licensePlate"
                  icon="sort-down"
                  isRequired={true}
                  searchName="searchLicensePlate"
                  sortQuery={'licensePlate,asc'}
                />
              </FormControlDefault>
              <RegisterButton />
            </BoxForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default BlockScreenUpdate;
